/**
 * @generated SignedSource<<7df99eee40402b1ce77aa63348dbc455>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MusicParseStatus = "ERROR" | "IN_PROGRESS" | "NOT_STARTED" | "SKIPPED" | "SUCCESS" | "%future added value";
export type MusicParseStepBarFinderUserConfirmationInput = {
  deleted_bar_storage_names: ReadonlyArray<string>;
  page_id: string;
  parse_step_id: string;
};
export type BarFinderUserConfirmationMutation$variables = {
  input: MusicParseStepBarFinderUserConfirmationInput;
};
export type BarFinderUserConfirmationMutation$data = {
  readonly music_parse_step_bar_finder_user_confirmation: {
    readonly parse_step: {
      readonly id: string;
      readonly status: MusicParseStatus;
    };
  };
};
export type BarFinderUserConfirmationMutation = {
  variables: BarFinderUserConfirmationMutation$variables;
  response: BarFinderUserConfirmationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MusicParseStepOutput",
    "kind": "LinkedField",
    "name": "music_parse_step_bar_finder_user_confirmation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicParseStep",
        "kind": "LinkedField",
        "name": "parse_step",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BarFinderUserConfirmationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BarFinderUserConfirmationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4b26fd5b7c3bb0f6695e4ab36744bf42",
    "id": null,
    "metadata": {},
    "name": "BarFinderUserConfirmationMutation",
    "operationKind": "mutation",
    "text": "mutation BarFinderUserConfirmationMutation(\n  $input: MusicParseStepBarFinderUserConfirmationInput!\n) {\n  music_parse_step_bar_finder_user_confirmation(input: $input) {\n    parse_step {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6c939313ebdf9b7548417ccd2eca26b";

export default node;
